import HTTP from '@/api/HTTP';
import transformer from '@/services/logistique/demandeImpression/demandeImpressionServerTableDataTransformer';

const URL_BASE = 'gescom/DemandeImpression/';

export async function create(demande) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', demande);
  return response;
}

export async function createAll(demandes) {
  const response = await HTTP.post(URL_BASE + 'CreateAllAsync', demandes);
  return response;
}

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function update(demande) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', demande);
  return response;
}

export async function getAll(serverTabledata) {
  const inputServer = transformer(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function deleteDemandeImpression(id) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', { params: { id: id } });
  return response;
}

export async function createOTs(ids) {
  const response = await HTTP.post(URL_BASE + 'CreateOTsAsync', ids);
  return response;
}

export async function updateEtatDemandeImpressionAll(params) {
  const response = await HTTP.put(URL_BASE + 'UpdateEtatAllAsync', params);
  return response;
}

export async function updateCampagneDemandeImpressionAll(params) {
  const response = await HTTP.put(URL_BASE + 'UpdateCampagneAllAsync', params);
  return response;
}
export async function updateNomFichierDemandeImpressionAll(params) {
  const response = await HTTP.put(URL_BASE + 'UpdateNomFichierAllAsync', params);
  return response;
}
export async function updateGraphisteDemandeImpressionAll(params) {
  const response = await HTTP.put(URL_BASE + 'UpdateGraphisteAllAsync', params);
  return response;
}
export async function updateDateDemandeImpressionAll(params) {
  const response = await HTTP.put(URL_BASE + 'UpdateDateAllAsync', params);
  return response;
}
export async function updateQuantiteDemandeImpressionAll(params) {
  const response = await HTTP.put(URL_BASE + 'UpdateQuantiteAllAsync', params);
  return response;
}
